module.exports = __webpack_public_path__ + "static/media/31.63c2c360.png";